// extracted by mini-css-extract-plugin
export default {"root":"PlasmicMenuSelectStack_root__XvIJ8","roothidden":"PlasmicMenuSelectStack_roothidden__YoEkS"};